import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-11c64f7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "itm" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "itm__item-instance-num" }
const _hoisted_4 = { class: "itm__item-instance-channel" }
const _hoisted_5 = { class: "itm__item-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiStatusIndicator = _resolveComponent("UiStatusIndicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.notify(item) ? 'itm__item itm__item_notify' : 'itm__item'),
        key: index
      }, [
        _createElementVNode("div", {
          class: "itm__item-instance",
          onClick: ($event: any) => (
					_ctx.onClickRedirect(
						'instance-detail',
						item.instance,
						item.channel
					)
				)
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(item.instance) + " ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatChannel(item.sourceName, item.channel)), 1)
          ]),
          (_ctx.hasExpirePaymentStamp(item.expirePaymentStamp))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(
						_ctx.notify(item)
							? 'itm__item-instance-expire itm__item-instance-expire_notify'
							: 'itm__item-instance-expire'
					)
              }, " истекает " + _toDisplayString(_ctx.dataTimeFormat(item.expirePaymentStamp)), 3))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UiStatusIndicator, {
            value: item.status
          }, null, 8, ["value"])
        ])
      ], 2))
    }), 128))
  ]))
}